import { getBlogPosts } from './blog';
import { getResearchPosts } from './research';
import { getCaseStudies } from './case-studies';

export type ResourceType = 'blog' | 'research' | 'case-study';

export interface Resource {
    id: string; // slug or unique ID
    type: ResourceType;
    title: string;
    description: string;
    image?: string;
    date?: string; // ISO string YYYY-MM-DD
    order?: number;
    link: string;
    tags?: string[];
}

export function getAllResources(): Resource[] {
    const blogs: Resource[] = getBlogPosts().map((post) => ({
        id: post.slug,
        type: 'blog',
        title: post.title,
        description: post.excerpt,
        image: post.image,
        date: post.date,
        order: post.order,
        link: `/resources/blog/${post.slug}`,
        tags: post.tags,
    }));

    const research: Resource[] = getResearchPosts().map((post) => ({
        id: post.slug,
        type: 'research',
        title: post.title,
        description: post.excerpt,
        image: post.image,
        date: post.date,
        order: post.order,
        link: `/resources/research/${post.slug}`,
        tags: post.tags,
    }));

    const caseStudies: Resource[] = getCaseStudies().map((study) => ({
        id: study.slug,
        type: 'case-study',
        title: study.title,
        description: study.excerpt,
        image: study.image,
        date: study.date,
        order: study.order,
        link: `/resources/case-studies/${study.slug}`,
        tags: study.tags,
    }));

    // Ordered articles first (lowest number first), then by date (newest first)
    return [...blogs, ...research, ...caseStudies].sort((a, b) => {
        if (a.order != null && b.order != null) return a.order - b.order;
        if (a.order != null) return -1;
        if (b.order != null) return 1;
        if (!a.date) return 1;
        if (!b.date) return -1;
        return new Date(b.date).getTime() - new Date(a.date).getTime();
    });
}

export function getFeaturedResource(type: ResourceType): Resource | undefined {
    return getAllResources().find((r) => r.type === type);
}

export function getResourcesByType(type: ResourceType): Resource[] {
    return getAllResources().filter((r) => r.type === type);
}
